export type IdeoDragEffect = 'copy' | 'move';

export interface IdeoDragSession<T = any>
{
    active: boolean;
    data: T | null;
    type: string;
    effect: IdeoDragEffect;
    keyboard: boolean;
}

export const ideoDragSession = reactive<IdeoDragSession>({
    active: false,
    data: null,
    type: '',
    effect: 'move',
    keyboard: false
});

export function startIdeoDragSession(data: any, type: string, effect: IdeoDragEffect, keyboard = false)
{
    ideoDragSession.active = true;
    ideoDragSession.data = data;
    ideoDragSession.type = type;
    ideoDragSession.effect = effect;
    ideoDragSession.keyboard = keyboard;
}

export function clearIdeoDragSession()
{
    ideoDragSession.active = false;
    ideoDragSession.data = null;
    ideoDragSession.type = '';
    ideoDragSession.effect = 'move';
    ideoDragSession.keyboard = false;
}
